<script setup lang="ts">
import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';
</script>

<template>
  <Button
    :class="
      cn(
        'gap-2.5 rounded-[2px] rounded-bl-[25px] bg-filler-50 px-3 py-2 pe-[25px] text-left text-xl font-semibold text-white ring-0 transition-[background-color_width] duration-300 hover:bg-white hover:text-filler-50 hover:ring-[3px] hover:ring-filler-50 focus-visible:bg-white focus-visible:text-filler-50',
        $attrs.class ?? '',
      )
    "
  >
    <slot />
  </Button>
</template>
